export default __webpack_public_path__ + "static/media/plus.dd5c59bc.svg";